const IP_BACKEND_DNS = 'https://api.testb19.be/admin'
const IP_BACKEND_DNS_AUTH = 'https://apiauth.testb19.be/api/admin'

module.exports = {
  IP_BACKEND_DNS,
  IP_BACKEND_DNS_AUTH
}
